import { FC } from 'react'

import { IconShare } from 'components/icons/share'
import { buildShareUrl } from './helpers'
import { AnimatePresence, Variants } from 'framer-motion'
import { Facebook } from './icons/facebook'
import { Instagram } from './icons/instagram'
import { YouTube } from './icons/youtube'
import { Button, ShareContainer, ShareContent, ShareToggle } from './styled'
import { WhatsApp } from './icons/whatsapp'
import { X } from './icons/x'
import { strings } from 'lang/strings'
import { config } from 'config'

const shareOptions = [
  {
    Component: Facebook,
    shareLink: buildShareUrl('facebook'),
    profileLink: strings[config.language].footer.social.facebook,
  },
  {
    Component: X,
    shareLink: buildShareUrl('twitter'),
    profileLink: strings[config.language].footer.social.x,
  },
  {
    Component: WhatsApp,
    shareLink: buildShareUrl('whatsapp'),
  },
  {
    Component: YouTube,
    profileLink: strings[config.language].footer.social.youtube,
  },
  {
    Component: Instagram,
    profileLink: strings[config.language].footer.social.instagram,
  },
]

const iconContainerVariants: Variants = {
  hidden: {
    width: 0,
    transition: {
      when: 'afterChildren',
      staggerChildren: 0.05,
    },
  },
  visible: {
    width: 'auto',
    transition: {
      delayChildren: 0.3,
      staggerChildren: -0.08,
    },
  },
}

const iconVariants: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
}

export const Share: FC<{
  isVisible?: boolean
  onToggle?: () => void
  isShare?: boolean
  onOpen?: () => void
  onClose?: () => void
}> = ({ isShare, isVisible, onToggle }) => {
  return (
    <ShareContent>
      <AnimatePresence>
        {isVisible && (
          <ShareContainer
            variants={iconContainerVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            $isShare={isShare}
            $spacing={isShare ? 'small' : 'large'}
          >
            {(isShare
              ? shareOptions.filter(o => !!o.shareLink)
              : shareOptions.filter(o => !!o.profileLink)
            ).map(({ Component, ...o }, i) => (
              // eslint-disable-next-line react/jsx-no-target-blank
              <Button
                variants={iconVariants}
                href={isShare ? o.shareLink : o.profileLink}
                target="_blank"
                key={i}
              >
                <Component />
              </Button>
            ))}
          </ShareContainer>
        )}
      </AnimatePresence>

      {isShare && (
        <ShareToggle
          onClick={() => typeof onToggle === 'function' && onToggle()}
        >
          <IconShare />
        </ShareToggle>
      )}
    </ShareContent>
  )
}
